"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.golf = exports.eids = exports.breakpoints = void 0;
var _golfToEid = _interopRequireDefault(require("golf-to-eid"));
//
// Define the breakpoints the manifest need to listen to.
//
const breakpoints = ['mobile', 'phablet', 'tablet', 'desktop', 'large'];

//
// Golf translation ids
//
exports.breakpoints = breakpoints;
const golf = {
  allProducts: 'Shared:ProductNav:AllProducts',
  callUs: 'Shared:UtilityBar:SupportPhone:CallUs',
  help: 'Shared:Help:HeaderLink',
  myAccount: 'Sales:Footer:MyAccount:ManageYourAccount'
};

//
// Generate Traffic2 eid's to be used to track clicks. Map the generated
// strings back to the same keys the Golf translations strings have.
//
exports.golf = golf;
const golfKeys = Object.keys(golf);
const eidStrings = (0, _golfToEid.default)(golfKeys.map(key => golf[key]), {
  prefix: 'uxp.hyd.all_products',
  postfix: 'link.click'
});
const eids = golfKeys.reduce((eid, key, index) => {
  eid[key] = eidStrings[index];
  return eid;
}, {});
exports.eids = eids;